module.exports = __webpack_public_path__ + "img/khbk.00600f26.png";